const OddsSpacer = () => (
  <div className="h-[40px] md:h-[35px] w-full" />
);

export default OddsSpacer;
